import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { RmCountPriceListService } from './rm-count-pricelist-service';
import {
  SkuPriceByDateRequestDto,
  SkuPriceCreateRequestDto,
  SkuPriceHistoryRequestDto,
  SkuMaxEffectiveDateRequestDto,
} from '@gtpl/shared-models/raw-material-procurement';

@ApiTags('sku-price')
@Controller('sku-price')
export class SkuPriceController {
  constructor(
    private readonly skuPriceService: RmCountPriceListService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
  ) {}

  @Post('/createSkuPrice')
  async createSkuPrice(@Body() req: SkuPriceCreateRequestDto): Promise<CommonResponse> {
    try {
      return await this.skuPriceService.createSkuPrice(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getCurrentSkuPrices')
  async getCurrentSkuPrices(@Body() req?:any): Promise<CommonResponse> {
    try {
      return await this.skuPriceService.getCurrentSkuPrices(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSkuPriceByDate')
  async getSkuPriceByDate(@Body() req: any): Promise<CommonResponse> {
    try {
      return await this.skuPriceService.getSkuPriceByDate(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSkuPriceHistory')
  async getSkuPriceHistory(@Body() req: SkuPriceHistoryRequestDto): Promise<CommonResponse> {
    try {
      return await this.skuPriceService.getSkuPriceHistory(req);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }

  @Post('/getSkuMaxEffectiveDate')
  async getSkuMaxEffectiveDate(@Body() req: SkuMaxEffectiveDateRequestDto): Promise<CommonResponse> {
    try {
      return await this.skuPriceService.getSkuMaxEffectiveDate(req.skuId);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(CommonResponse, err);
    }
  }
}
